/**
 * Parse the system-of-record value(s) the Tier-2 verify-against-source gate
 * carries in ``ExecuteActionResponse.error_meta.source_values`` — a defensive
 * ``string[]`` read shared by every action surface that renders the recovery
 * card (ScalarActionProposalMount, FocusedActionView). One place owns the wire
 * shape so the UI component (`ActionErrorRecovery`) stays wire-agnostic.
 */
export function readSourceValues(
  errorMeta: Readonly<Record<string, unknown>> | null | undefined,
): string[] | null {
  const raw = errorMeta?.source_values;
  return Array.isArray(raw) ? raw.filter((x): x is string => typeof x === "string") : null;
}
